import { Cale_unsyncedEvents } from '../Cale/Cale.unsyncedEvents'
import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import { IDB_reportsReadAll } from '../IDB/IDB.table.report'
import ActivityStore from '../../src/stores/activity'
import { appUploadQueue } from '../Uplo/AppUploadQueue'
import { Flow_hasUnuploadedAnswers } from '../Flow/Flow.answer'

import {
    IDB_flowActionReports,
    IDB_posts,
    IDB_unsyncedConfirmedActions,
    IDB_flowReports,
    IDB_photos,
} from '../IDB/IDB.dexie'
import { isAppFlowWorkflow } from '../../../shared/domain/workflows/types.no-deps'
import { IDB_workflowRead } from '../IDB/IDB.table.workflow'

export async function Sync_hasUnsyncedData() {
    // In progress activity report
    if (ActivityStore.hasCurrentActivity() && !ActivityStore.hasCurrentGuideActivity()) return true

    // In progress flow reports
    const hasUnsyncedFlowReports = await getHasUnsyncedFlowReports()
    if (hasUnsyncedFlowReports) return true

    // Completed reports
    const reports = await IDB_reportsReadAll()
    if (reports.some((report) => !report.uploaded)) return true

    // Posts
    const postsCount = await IDB_posts().where({ status: 'pendingSync' }).count()
    if (postsCount > 0) return true

    // CalendarEvents
    if (!Cust_hasSingleLocation()) {
        const events = await Cale_unsyncedEvents()
        if (events.length > 0) return true
    }

    // Action reports
    const actionReportsCount = await IDB_flowActionReports().count()
    if (actionReportsCount > 0) return true

    // Confirmed actions (deprecated)
    const confirmedActionsCount = await IDB_unsyncedConfirmedActions().count()
    if (confirmedActionsCount > 0) return true

    // Report images
    const pendingPhotosCount = await IDB_photos()
        .filter((photo) => photo.status !== 'uploaded')
        .count()
    if (pendingPhotosCount > 0) return true

    // Uploads
    if (await appUploadQueue.hasUnsyncedData()) return true

    return false
}

async function getHasUnsyncedFlowReports(): Promise<boolean> {
    // Get the ids of all the reports
    const reportClientIds = await IDB_flowReports().orderBy('startDate').reverse().primaryKeys()

    for (const reportClientId of reportClientIds) {
        const flowReport = await IDB_flowReports().get(reportClientId)

        // If legacy report before multi-user reports
        if (flowReport.collaborators == null) {
            // And the report is open, then there is unsynced data
            if (flowReport.status === 'open') return true

            // Otherwise move onto the next report
            continue
        }

        // Get workflow for the flow report
        const workflow = await IDB_workflowRead(flowReport.workflow.id)

        const isGuideReport = isAppFlowWorkflow(workflow) && workflow.type === 'guide'

        // If the report is not in uploaded state, then there is unsynced data
        if (flowReport.uploadState !== 'uploaded' && !isGuideReport) return true

        // Find out if the report has unuploaded answers
        const hasUnuploadedAnswers = await Flow_hasUnuploadedAnswers(flowReport.id)
        if (hasUnuploadedAnswers && !isGuideReport) return true
    }

    return false
}
